/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author:
 * Created: 16/10/23
 */

import { Location } from 'react-router-dom';

export type NavigationRoute = {
    title: string;
    key: string;
    when: string[];

    path?: string;
    getPath?: (location: Location) => string;
};

function showNavigation(supervisor: boolean | undefined, admin: boolean): NavigationRoute[] {
    const routes: NavigationRoute[] = [
        {
            title: 'My Workplan',
            key: 'dashboard',
            when: ['/', '/workplan/:id/:version'],
            getPath: (location) => {
                if (location.pathname.startsWith('/workplan')) {
                    const params = location.pathname.match(/\d+/g);
                    if (params && params.length >= 2) return `/workplan/${params[0]}/${params[1]}`;
                }
                return '/';
            },
        },
    ];

    if (supervisor) {
        routes.push({
            title: 'My Staff Workplans',
            key: 'supervisor',
            when: ['/supervisor'],
            path: '/supervisor',
        });
    }

    if (admin) {
        routes.push({
            title: 'Admin',
            key: 'admin',
            when: ['/admin'],
            path: '/admin',
        });
    }

    return routes;
}

export { showNavigation };
